import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Tutorials from '../views/Tutorials.vue'
import store from '../store/index.js'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:'/dashboard'
  // },
  {
    path: '/dashboard',
    component: Dashboard,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('checkLogin');
      if(store.getters.getLoggedIn) {
        await store.dispatch('updateUser'); 
        next();
      }else{
        next('/login');
      }
    },
    
    children:[
      {
        path:'',
        name: 'DashboardHome',
        component: () => import('../views/DashboardHome.vue')
      },
      {
        path: 'appSettings',
        name: 'AppSettings',
        component: () => import('../views/AppSettings.vue')
      },
      {
        path: 'billing',
        name: 'Billing',
        component: () => import('../views/Billing.vue')
      },
      {
        path: 'connectCarriers',
        name: 'ConnectCarriers',
        component: () => import('../views/ConnectCarriers.vue')
      },
      {
        path: 'connectPlatforms',
        name: 'ConnectPlatforms',
        component: () => import('../views/ConnectPlatforms.vue')
      },
      {
        path: 'wizard/:id([0-4]+?)',
        name: 'Gandalf',
        props: true,
        component: () => import('../views/Gandalf.vue')
      },
      {
        path: 'dispatch',
        name: 'Dispatch',
        // props: true,
        component: () => import('../views/Dispatch.vue')
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('../views/Notifications.vue')
      },
      {
        path: 'notification/:id',
        name: 'Notification',
        props: true,
        component: () => import('../views/Notification.vue')
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/Orders.vue')
      },
      {
        path: 'plans',
        name: 'Plans',
        props: true,
        component: () => import('../views/Plans.vue')
      },
      {
        path: 'presets',
        name: 'Presets',
        component: () => import('../views/Presets.vue')
      },
      {
        path: 'refunds',
        name: 'Refunds',
        component: () => import('../views/Refunds.vue')
      },
      {
        path: 'refund/:id',
        name: 'Refund',
        props: true,
        component: () => import('../views/Refund.vue')
      },
      {
        path: 'returns/:returnLabelId?',
        name: 'Returns',
        props:true,
        component: () => import('../views/Returns.vue')
      },
      {
        path: 'return/:id',
        name: 'Return',
        props: true,
        component: () => import('../views/Return.vue')
      },
      {
        path: 'returnAddresses',
        name: 'ReturnAddresses',
        // retrunAddresses
        component: () => import('../views/ReturnAddresses.vue')
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('../views/Support.vue')
      },
      {
        path: 'install/confirmation',
        name: 'InstallConfirmation',
        component: () => import('../views/InstallConfirmation.vue')
      },
      {
        path: 'userProfile',
        name: 'UserProfile',
        component: () => import('../views/UserProfile.vue')
      },
      {
        path: 'widget',
        name: 'widget'
      }
      
    ]
  },  
  {
    path: '/login',
    name: 'Login',    
    beforeEnter: async (to, from, next) => {      
      await store.dispatch('checkLogin')
      if(store.getters.getLoggedIn == true){
        next('/dashboard')
      }else{
        next()
      }
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  },
  {
    path: '/register',
    name: 'Register',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('checkLogin')      
      if(store.getters.getLoggedIn == true){
        
        next('/dashboard')
      }else{
        next()
      }
    },
    component: () => import( '../views/Register.vue')
  },
  {
    path: '/recoverPassword',
    name: 'RecoverPassword',
    component: () => import( '../views/RecoverPassword.vue')
  },
  {
    path: '/tutorials',
    component:Tutorials,
    children:[
      {
        path:'fedexConnection',
        name:'FedexConnection',
        component: () => import( '../components/tutorials/FedexConnection.vue')
      },
      {
        path:'UPSConnection',
        name:'UPSConnection',
        component: () => import( '../components/tutorials/UPSConnection.vue')
      },
      {
        path:'USPSConnection',
        name:'USPSConnection',
        component: () => import( '../components/tutorials/USPSConnection.vue')
      },
      {
        path:'widgetInstall',
        name:'widgetInstall',
        component: () => import( '../components/tutorials/widgetInstall.vue')
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },  
  { 
    path: '*', 
    redirect: '/404' 
  }, 

  
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const dashboardRegex = /^\/dashboard(?:\/(?=$))?$/;
const BILLING_PATH = '/dashboard/billing';
const PLANS_PATH = '/dashboard/plans';
router.beforeResolve((to, from, next) => {
  // NOTE: only set rule for /dashboard children path
  // NOTE: this hook should act after updateUser
  if (dashboardRegex.test(to.matched[0].path)) {
    // NOTE: 'active' means they are paid up
    if (store.getters.getSubscriptionStatus && store.getters.getSubscriptionStatus !== 'active' && !store.getters.getShopifyBilling && to.path !== BILLING_PATH) {
      next(BILLING_PATH);
    } else if (!store.getters.getReturnsAvailable && to.path !== PLANS_PATH) {
      next(PLANS_PATH);
    } else {
      next();
    }
  } else {
    next();
  }
  
})
export default router
